<template>
  <nav
    class="navbar navbar-expand-lg navbar-dark shadow-sm fixed-top temple-navbar"
    :class="{ 'navbar-shift': sidebarOpen }"
  >
    <div
      class="container-fluid d-flex align-items-center justify-content-between"
    >
      <!-- Sidebar toggle -->
      <button
        class="btn btn-outline-light me-2"
        @click="$emit('toggle-sidebar')"
      >
        <i class="bi bi-list fs-5"></i>
      </button>

      <!-- Brand (centered normally, right of toggle on mobile) -->
      <router-link
        to="/"
        class="navbar-brand fw-bold d-flex align-items-center brand-text m-0"
        v-show="!sidebarOpen"
      >
        <img
          src="@/assets/lotus-icon.png"
          alt="Temple Logo"
          class="me-2 rounded-circle lotus-logo"
        />
        <span class="temple-name">{{ templeName }}</span>
      </router-link>

      <!-- Navbar Links (Right Side) -->
      <div class="d-none d-lg-block ms-auto">
        <router-link to="/contact" class="btn btn-outline-light btn-sm me-2">
          Contact
        </router-link>
        <router-link to="/donations" class="btn btn-warning btn-sm fw-bold">
          Donate 🙏
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  props: {
    sidebarOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      templeName: "Gallenawaththa Aranya Senasanaya",
    };
  },
};
</script>

<style scoped>
/* 🌅 Navbar background and structure */
.temple-navbar {
  background: linear-gradient(90deg, #8c6b4f, #c9a66b);
  opacity: 1 !important;
  z-index: 1050;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: margin-left 0.3s ease;
}

.navbar-shift {
  margin-left: 250px;
}

/* 🌸 Brand styles */
.lotus-logo {
  width: 40px;
  height: 40px;
  transition: all 0.3s ease;
}

.temple-name {
  font-size: 1.25rem;
  transition: all 0.3s ease;
}

/* 🕉 Center brand on normal screen */
.navbar .brand-text {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

/* 🌺 Mobile adjustments */
@media (max-width: 991px) {
  .brand-text {
    position: static;
    margin-left: auto;
    display: flex;
    align-items: center;
  }

  .lotus-logo {
    width: 28px;
    height: 28px;
    margin-right: 5px;
  }

  .temple-name {
    font-size: 0.95rem;
    white-space: nowrap;
  }

  /* Hide logo + text when sidebar is open */
  .navbar-shift .brand-text {
    display: none !important;
  }
}
</style>
